import { render } from "./Leaves.vue?vue&type=template&id=d324438e&scoped=true"
import script from "./Leaves.vue?vue&type=script&lang=js"
export * from "./Leaves.vue?vue&type=script&lang=js"

import "./Leaves.vue?vue&type=style&index=0&id=d324438e&lang=scss&scoped=true"

import exportComponent from "/builds/springup/oa-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d324438e"]])

export default __exports__